<ng-container *transloco="let t; scope: 'catalog'">
  <div class="default-max-width centered margin--top-l">
    <div class="flex flex--tablet-wrap flex--ai-start">
      <div class="flex--shrink-0 header-detail-slider">
        <div>
          <div class="flex">
            <app-image [image]="product | productManufacturerLogo" [classes]="'brand-logo'"></app-image>
            <app-image [image]="product | labelImage" [classes]="'label-logo brand-logo margin--left-m'"></app-image>
          </div>

          <br />

          <app-image-gallery [images]="product | productImages"></app-image-gallery>
        </div>
      </div>

      <div class="flex flex--d-column flex--jc-space-between flex--shrink-0 header-detail-infos">
        <div class="header-detail-top">
          <div class="margin--bottom-xl">
            <div class="margin--bottom-m">
              <h1 class="headline-special header-detail-title default-max-width-text">{{ product.sTitle }}<br /></h1>
            </div>
          </div>

          <div class="default-font-sizes default-font-sizes--big product-text" [innerHTML]="product.sDescription"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
